import { render } from "./LuxuryTravel05.vue?vue&type=template&id=39b75ec1&scoped=true"
import script from "./LuxuryTravel05.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel05.vue?vue&type=script&lang=js"

import "./LuxuryTravel05.scss?vue&type=style&index=0&id=39b75ec1&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b75ec1"]])

export default __exports__